import React from 'react';

const EstateDetailPage = () => {
  return <div>estateDetailPage</div>;
};

export default EstateDetailPage;
